import { configureStore } from "@reduxjs/toolkit";
import productsReducer  from "./Slices/ProductsSlice/ProductsSlice";

const store = configureStore({
    reducer:{
        products: productsReducer
    }
});

export default store;